export default __webpack_public_path__ + "static/media/register-artwork-4.41644672.svg";